/**
 * API Configuration
 */

export const apiConfig = {
  // Paymaster service URL for gasless transactions
  paymasterUrl: import.meta.env.VITE_PAYMASTER_URL || 'https://tokenbox-paymaster.up.railway.app',
};
